// StudyAbroadHero.js
import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import ConsultationModal from '../ConsultationModal';

const StudyAbroadHero = () => {
  const [showConsultationModal, setShowConsultationModal] = useState(false);

  return (
    <section className="relative w-full h-[600px] md:h-[700px] overflow-hidden bg-white">
      <div className="max-w-7xl mx-auto h-full grid md:grid-cols-2">
        {/* Left Content */}
        <div className="flex flex-col justify-center px-4 md:px-8 py-12 bg-surface">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            <span className="inline-block bg-white text-secondary text-xs font-light px-4 py-2 rounded-md mb-4">
              Study Abroad
            </span>
            
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-primary leading-tight mb-6">
              Plan Your International Studies on Solid Ground
            </h1>
            
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-8 max-w-xl font-light">
              From your first questions through to the final submission, Ivipass gives students a clear plan and practical help at every stage of the application, working through the academic institutions we have relationships with.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <button
                onClick={() => setShowConsultationModal(true)}
                className="bg-primary hover:bg-primary-hover text-white font-normal text-sm px-8 py-3 rounded-lg transition-colors text-center"
              >
                Arrange a Free Consultation
              </button>
            </div>
          </motion.div>
        </div>

        {/* Right Image */}
        <div className="relative hidden md:block">
          <div 
            className="absolute inset-0 bg-cover bg-center"
            style={{ 
              backgroundImage: `url(${require('../../assets/study-abroad-hero.jpg')})`,
            }}
          />
        </div>
      </div>

      {/* Consultation Modal */}
      <ConsultationModal 
        isOpen={showConsultationModal}
        onClose={() => setShowConsultationModal(false)}
        serviceType="study-abroad"
      />
    </section>
  );
};

export default StudyAbroadHero;
